import Subscribe from '../Subscribe';
import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

export default function B() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('delta2max.teaser');

    return (
        <div
            className={`d2x-teaser-B ${css.d2xTeaserB} GtmModuleData-section`}
            data-section-id={css.d2xTeaserB}
            data-section-title={t.rich('sec2_desc', {
                link: (text: string) => text,
            })}
        >
            <Subscribe />
            <div className="img-wrapper">
                <Link
                    className="GtmModuleData-btn-href"
                    href="https://lin.ee/g7W0VbD"
                    dataLayer={{
                        event: 'uaEvent',
                        event_name: 'line_icon_click',
                        button_name: 'Line',
                        url: 'https://lin.ee/g7W0VbD',
                        __btn_id1: css.d2xTeaserB,
                        __btn_id2: 'https://lin.ee/g7W0VbD',
                    }}
                >
                    <NextImage
                        onClick={() => {
                            try {
                                window?.fbq('track', 'Lead');
                            } catch (e) {
                                console.error(e);
                            }
                        }}
                        webpSrc={require('@publicLocal/delta2max/teaser/h5/jp/b_1.webp')}
                        src={require('@publicLocal/delta2max/teaser/h5/jp/b_1.png')}
                        alt={t('sec1_title')}
                        aria-label={t('sec1_title')}
                    />
                </Link>
                <NextImage
                    webpSrc={require('@publicLocal/delta2max/teaser/h5/jp/b_2.webp')}
                    src={require('@publicLocal/delta2max/teaser/h5/jp/b_2.png')}
                    alt={t('sec1_title')}
                    aria-label={t('sec1_title')}
                />
            </div>
            <div className="desc">
                {t.rich('sec2_desc', {
                    link: (text: string) => (
                        <div className="link-div" onClick={() => window?.fbq && window?.fbq('track', 'Lead')}>
                            <Link
                                className="link GtmModuleData-btn-href"
                                href={'https://lin.ee/MaT2hbS'}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'offical_line_join',
                                    button_name: text,
                                    url: 'https://lin.ee/MaT2hbS',
                                    __btn_id1: css.d2xTeaserB,
                                    __btn_id2: 'https://lin.ee/MaT2hbS',
                                }}
                            >
                                {text}
                            </Link>
                        </div>
                    ),
                })}
            </div>
        </div>
    );
}
